import type { LightUserType } from "@app/types/user";
import type { LiveAccess, LiveDocKind } from "@memo-air/protocol";

export type LiveDocAccess = LiveAccess;
export type { LiveDocKind };

export type LiveDocType = {
  sId: string;
  title: string;
  kind: LiveDocKind;
  conversationId: string | null;
  createdByAgentConfigurationId: string | null;
  createdAt: number;
  updatedAt: number;
};

export type LiveDocMemberType = {
  user: LightUserType;
  access: LiveDocAccess;
};

export type LiveDocConnectionType = {
  url: string;
  token: string;
  access: LiveDocAccess;
};

export type LiveActorType = {
  kind: "human" | "agent";
  id: string;
  name: string;
  onBehalfOf?: { id: string; name: string };
};

// What a card, a Library row or Home shows about a doc without opening it. The first value comes
// from GET /live-docs; live-server then pushes fresh ones to watchers.
export type LiveDocSummaryType = {
  lastEditor: LiveActorType | null;
  lastEditedAt: string | null;
  // When this viewer last opened the doc; null if never.
  seenAt: string | null;
  present: LiveActorType[];
  writing: { name: string; kind: "human" | "agent"; section: string | null }[];
  pending: {
    id: string;
    approverId: string | null;
    approverName: string | null;
    actor: LiveActorType;
    createdAt: string;
  }[];
};

// A huddle as the chat shows it: live while endedAt is null.
export type LiveHuddleType = {
  sId: string;
  callDocId: string;
  conversationId: string | null;
  startedAt: number;
  endedAt: number | null;
  participants: {
    id: string;
    name: string;
    kind: "human" | "agent";
    present: boolean;
  }[];
  notesDocId: string | null;
  summary: string | null;
};

// Notes and a summary are written within a minute of a huddle ending; past that, a huddle with
// neither had nothing worth writing up (or writing failed) and stops looking busy.
const huddleNotesWindowMs = 2 * 60_000;

export function isHuddleWritingNotes(huddle: LiveHuddleType, nowMs: number) {
  return (
    huddle.endedAt !== null &&
    huddle.notesDocId === null &&
    huddle.summary === null &&
    nowMs - huddle.endedAt < huddleNotesWindowMs
  );
}
